module.exports = __webpack_public_path__ + "img/cardImg.9fc832ac.jpeg";